<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <input class="form-control"
                           style="width: 150px"
                           type="search"
                           v-model="search.keyword"
                           placeholder="ชื่อเซลล์"
                           aria-label="Search"/>&nbsp

                    <!-- Search By Date Range -->
                    <label>วันที่</label>
                    <date-picker
                        v-model="search.start_date"
                        :format="changeFormat"
                        :lang="lang"
                        placeholder="วันเริ่มต้น">
                    </date-picker>
                    &nbsp&nbsp
                    <label>ถึง</label>
                    <date-picker
                        v-model="search.end_date"
                        :format="changeFormat"
                        :lang="lang"
                        placeholder="วันสิ้นสุด">
                    </date-picker>
                    &nbsp
                    <button @click="searchSeller"
                            class="btn btn-success my-2 my-sm-0"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp
                </form>
            </div>
        </nav>
        <div class="col-sm-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">รหัสเซลล์</th>
                    <th scope="col">ชื่อเซลล์</th>
                    <th scope="col">จำนวนค้างชำระ</th>
                    <th scope="col">ดูข้อมูล</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(seller, index) in sellers">
                    <td>{{ seller.id }}</td>
                    <td>{{ seller.name }}</td>
                    <td>{{ seller.invoices_total | currency }}</td>
                    <td>
                        <button class="btn btn-default next"
                                @click="goToReceivables(seller.id)">
                            <icon name="eye"></icon>
                            <span> ดูข้อมูล</span>
                        </button>
                        &nbsp
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <!--<div class="alert-danger">{{sellers}}</div>-->
        <div v-if="sellers.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getSellerPage">
            </vue-pagination>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";
import moment from "moment";
import Multiselect from "vue-multiselect";
import VuePagination from "../../Pagination";
import DatePicker from 'vue2-datepicker'

export default {
    components: {
        VuePagination,
        Multiselect,
        DatePicker
    },
    name: "receivable-sellers",
    data() {
        return {
            checkbox_id: [],
            select_all: 'false',
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    created() {
        this.$store.dispatch("ReceivableSeller/setSellers");
        this.$store.dispatch("ReceivableSeller/clearSearch");
    },
    computed: {
        ...mapState({
            sellers: state => {
                return state.ReceivableSeller.sellers
            },
            dataPaginate: state => {
                return state.ReceivableSeller.dataPaginate;
            },
            search: state => {
                return state.ReceivableSeller.search
            }
        }),
    },
    methods: {
        searchSeller() {
            this.$store.dispatch("ReceivableSeller/setSearch", {
                keyword: this.search.keyword,
                start_date: this.search.start_date ?
                    moment(this.search.start_date).format('YYYY-MM-DD') :
                    "",
                end_date: this.search.end_date ?
                    moment(this.search.end_date).format('YYYY-MM-DD') :
                    "",
            })
                .then(() => this.$store.dispatch("ReceivableSeller/setSellers"))
        },
        getSellerPage() {
            this.$store.dispatch("ReceivableSeller/setSellers")
        },
        goToReceivables(sellerId) {
            this.$router.push('/accounting/billing/receivable/' + sellerId)
        }
    }
}
</script>

<style scoped>
.select {
    border: 0;
}
</style>
